const BorrowerType = {
  Borrower: 0,
  Guarantor: 1,
};

export default BorrowerType;
